import { FC } from 'react'

import { mergeArrayToString } from 'commons/utils/mergeArrayToString'
import { Info, InfoSet, InfoSetDirection } from 'ui/components/Info'

import { AddressInformationProps } from './AddressInformationProps'

export const AddressInformation: FC<AddressInformationProps> = (props) => {
  const {
    physicalAddress: { street: pStreet, city: pCity, state: pState, postalCode: pPostalCode, country: pCountry },
    mailingAddress: { street: mStreet, city: mCity, state: mState, postalCode: mPostalCode, country: mCountry }
  } = props

  const pAddress = mergeArrayToString(', ', [pStreet, pCity, pState, pPostalCode, pCountry])
  const mAddress = mergeArrayToString(', ', [mStreet, mCity, mState, mPostalCode, mCountry])

  return (
    <InfoSet legend="Address Information" direction={InfoSetDirection.COLUMN}>
      <Info label="Physical Address">{pAddress}</Info>
      <Info label="Mailing Address">{mAddress}</Info>
    </InfoSet>
  )
}
